'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ENVS = exports.ENVS = {
  Local: 'Local',
  Qa: 'Qa',
  Staging: 'Staging',
  Production: 'Production'
};

var APIGEE_URL_STAGING = 'https://developer-stg.api.autodesk.com';
var APIGEE_URL_PROD = 'https://developer.api.autodesk.com';
var API_NAME = 'locations';

// Base Domain
var getBaseUrlForEnv = exports.getBaseUrlForEnv = function getBaseUrlForEnv(env, apigeeUrl) {
  var _apigeeBaseUrls, _serviceUris;

  var apigeeBaseUrls = (_apigeeBaseUrls = {}, _defineProperty(_apigeeBaseUrls, ENVS.Local, 'http://local-locations.autodesk.com:3000'), _defineProperty(_apigeeBaseUrls, ENVS.Qa, APIGEE_URL_STAGING), _defineProperty(_apigeeBaseUrls, ENVS.Staging, APIGEE_URL_STAGING), _defineProperty(_apigeeBaseUrls, ENVS.Production, APIGEE_URL_PROD), _apigeeBaseUrls);
  var serviceUris = (_serviceUris = {}, _defineProperty(_serviceUris, ENVS.Local, ''), _defineProperty(_serviceUris, ENVS.Qa, '/construction/' + API_NAME + '-qa'), _defineProperty(_serviceUris, ENVS.Staging, '/construction/' + API_NAME), _defineProperty(_serviceUris, ENVS.Production, '/construction/' + API_NAME), _serviceUris);

  return '' + (apigeeUrl || apigeeBaseUrls[env]) + serviceUris[env];
};

// Currently support version 1
var DEFAULT_API_VERSION = exports.DEFAULT_API_VERSION = 'v2';
var DEFAULT_ENV = exports.DEFAULT_ENV = ENVS.Qa;

/**
 * The main configuration class used by all services to get options.
 */

var Config = function () {

  /**
   * Create the configuration object with a set of options.
   * * options optional parameters:
   * * baseURL - will override the entire baseURL
   * * apigeeUrl - will override only the apigee dns address of the url
   * * apiVersion - overrides the default api version of the sdk
   */
  function Config(options) {
    _classCallCheck(this, Config);

    this._options = {
      // Basic environments to config API URLs and http provider.
      env: ENVS.Qa,
      apiVersion: DEFAULT_API_VERSION
    };

    _extends(this._options, options);

    this._setBaseUrl();
  }

  /**
   * Setup base url
   */


  _createClass(Config, [{
    key: '_setBaseUrl',
    value: function _setBaseUrl() {
      this._baseUrl = this._options.baseURL || getBaseUrlForEnv(this._options.env, this._options.apigeeUrl) + '/' + this._options.apiVersion + '/';
    }
  }, {
    key: 'baseUrl',
    get: function get() {
      return this._baseUrl;
    }
  }]);

  return Config;
}();

exports.default = Config;